import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const DatabaseContainerLoader: LoadableType<{
	contentId: string;
	spaceKey: string;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DatabaseContainer" */ './DatabaseContainer.tsx'))
			.DatabaseContainer,
});
